import { Pipe, PipeTransform } from '@angular/core';
import {
  format,
  parse,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
} from 'date-fns';

@Pipe({
  name: 'dataValidadeFormat',
})
export class DataValidadeFormatPipe implements PipeTransform {
  transform(value: string, dateFormat: string = 'dd/MM/yyyy'): any {
    if (!value) return { formattedDate: '-', icon: null, tooltip: null };

    let date: Date;
    if (value.includes('T')) {
      date = new Date(value);
    } else {
      date = parse(value, 'yyyy-MM-dd', new Date());
    }

    const formattedDate = format(date, dateFormat);
    const daysDifference = differenceInDays(date, new Date());
    let hoursDifference = 0;
    let minutesDifference = 0;

    if (daysDifference === 0) {
      hoursDifference = differenceInHours(date, new Date());
      minutesDifference = differenceInMinutes(date, new Date());
    }

    let icon: string | null = null;
    let tooltip: string | null = null;

    if (daysDifference < 0) {
      icon = 'dangerous';
      tooltip = 'Vencido';
    } else if (
      daysDifference === 0 &&
      hoursDifference < 0 &&
      minutesDifference > 0
    ) {
      icon = 'warning';
      tooltip = `${minutesDifference} minutos até o dia do vencimento`;
    } else if (daysDifference === 0 && hoursDifference > 0) {
      icon = 'warning';
      tooltip = `${hoursDifference} horas até o dia do vencimento`;
    } else if (daysDifference === 0) {
      icon = 'warning';
      tooltip = `Vence hoje`;
    } else if (daysDifference === 1) {
      icon = 'warning';
      tooltip = '1 dia até o vencimento';
    } else if (daysDifference > 1 && daysDifference <= 30) {
      icon = 'warning';
      tooltip = `${daysDifference} dias até o vencimento`;
    }

    return { formattedDate, icon, tooltip };
  }
}
